import { render, staticRenderFns } from "./BaseMessage.vue?vue&type=template&id=9f84a76c"
import script from "./BaseMessage.vue?vue&type=script&lang=js"
export * from "./BaseMessage.vue?vue&type=script&lang=js"
import style0 from "./BaseMessage.vue?vue&type=style&index=0&id=9f84a76c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports